import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const LowPriorityIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 5L22 5L22 7L14 7L14 5ZM14 10.5L22 10.5L22 12.5L14 12.5L14 10.5ZM14 16L22 16L22 18L14 18L14 16ZM2 11.5C2 15.08 4.92 18 8.5 18L9 18L9 20L12 17L9 14L9 16L8.5 16C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7L12 7L12 5L8.5 5C4.92 5 2 7.92 2 11.5Z"
      fill="currentColor"
    />
  </svg>
);

LowPriorityIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(LowPriorityIcon);
